import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import ResourceUtils from "@/utils/resource-utils";
import GameObject = Phaser.GameObjects.GameObject;
import {Amount} from "@/model/amount";
import SpriteUtils from "@/utils/sprite-utils";
import SContainer from "@/cmp/s-container";
import CU from "@/utils/c-u";

export class AmountPanel extends SContainer {

    private readonly PROGRESS_VALUES_DISTANCE: number = 10;
    private readonly INFO_FONT_SIZE: number = 12;
    private readonly INFO_FONT_STYLE: string = 'bold';

    constructor(scene: Phaser.Scene, x: number, y: number, text: string, t: Amount) {
        super(scene, x, y);

        let rewardMap = ResourceUtils.convertRes(t.gold, t.crystal, t.elixir, t.mithril, 0);

        let rewardItems: GameObject[] = [];
        let rewardTxt = TextUtils.addTextAdvanced(scene, text, 0, 0,
            '#92908b', this.INFO_FONT_SIZE, this.INFO_FONT_STYLE, 320, 'left', 1, Fonts.ARIAL_MT)
        rewardTxt.setOrigin(0, 0).setStroke('#000000', 1);
        rewardItems.push(rewardTxt);
        let posX = rewardTxt.getRightCenter().x! / CU.S + this.PROGRESS_VALUES_DISTANCE;
        let posY = rewardTxt.y / CU.S;
        for (let [resType, resValue] of rewardMap) {
            let countText = TextUtils.addTextAdvanced(scene, TextUtils.formatMoney(resValue), posX, posY,
                '#c3c3c3', this.INFO_FONT_SIZE, 'normal', 320, 'left', 1, Fonts.ARIAL_MT);
            countText.setOrigin(0, 0).setStroke('#000000', 1);

            rewardItems.push(countText);
            posX = countText.getRightCenter().x! / CU.S + 1

            let countIcon = SpriteUtils.addSprite(this.scene!, posX, posY - 3, ResourceUtils.getResourceImageNoShadow(resType))
                .setOrigin(0, 0);
            SpriteUtils.setDispSize(countIcon, 30 * CU.S, 30 * CU.S);

            rewardItems.push(countIcon);
            posX = countIcon.getRightCenter().x! / CU.S + 8
        }

        this.add([...rewardItems]);
    }
}
